import { render, staticRenderFns } from "./TheImage.vue?vue&type=template&id=570d7f31&scoped=true&"
import script from "./TheImage.vue?vue&type=script&lang=js&"
export * from "./TheImage.vue?vue&type=script&lang=js&"
import style0 from "./TheImage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TheImage.vue?vue&type=style&index=1&id=570d7f31&lang=scss&scoped=true&"
import style2 from "./TheImage.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570d7f31",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheButton: require('/web/components/TheButton.vue').default})
